export class FileStore {
    constructor(key) {
        this.key = key;
    }
    async ensureFile(initialData) {
        if (localStorage.getItem(this.key) === null) {
            await this.write(initialData);
        }
    }
    async read() {
        const data = localStorage.getItem(this.key);
        if (data === null) {
            throw new Error(`No data found for key: ${this.key}`);
        }
        return JSON.parse(data);
    }
    async write(data) {
        localStorage.setItem(this.key, JSON.stringify(data));
    }
    getPath() {
        return this.key;
    }
    async clear() {
        localStorage.removeItem(this.key);
    }
    static createInUserData(key) {
        return new FileStore(key);
    }
}
